import { Navigate } from "react-router-dom";
import FeeConfiguration from "./pages/pricing/fee-config";
import PricingOutlet from "./pages/pricing/pricing-outlet";
import ReferralOutlet from "./pages/commission/commission-outlet";
import ProductsTable from "./pages/pricing/products-table";
import ProductsCategories from "./pages/category/product-categories";
import Commissions from "./pages/commission/commissions";
import CommissionPayouts from "./pages/commission/payouts";
import CategoryUsers from "./pages/category/category-users";
import CategoryOutlet from "./pages/category/category-outlet";
import ProfitCalculation from "./pages/category/profit-calculation";

const AdminPricingRoutes = [
  {
    path: "/admin-pricing",
    children: [
      {
        path: "categories",
        element: <CategoryOutlet />,
        children: [
          {
            index: true,
            element: <Navigate to="category" replace />,
          },
          { path: "category", element: <ProductsCategories /> },
          { path: "profit-calculation", element: <ProfitCalculation /> },
          {
            path: "category/users/:categoryId",
            element: <CategoryUsers />,
          },
        ],
      },
      {
        path: "pricing",
        element: <PricingOutlet />,
        children: [
          {
            index: true,
            element: <Navigate to="products-table" replace />,
          },
          { path: "products-table", element: <ProductsTable /> },
          { path: "fee-config", element: <FeeConfiguration /> },
        ],
      },
      {
        path: "commission",
        element: <ReferralOutlet />,
        children: [
          {
            index: true,
            element: <Navigate to="commissions" replace />,
          },
          { path: "commissions", element: <Commissions /> },
          { path: "payouts", element: <CommissionPayouts /> },
        ],
      },
    ],
  },
];

export default AdminPricingRoutes;
